import React from 'react';
import { Box, Container, List, ListItem, ListItemText, Typography } from '@mui/material';
import SEO from '../components/SEO';

const KundlistarVsKundliSoft: React.FC = () => (
  <>
    <SEO
      title="Kundlistar Studio vs KundliSoft - Astrology Software Comparison"
      description="Compare Kundlistar Studio and KundliSoft. Kundlistar Studio is an iPhone astrology workspace with Vedic, KP, Nadi, BNN, Jaimini, Numerology and client-management tools."
      path="/kundlistar-studio-vs-kundlisoft"
      keywords="Kundlistar Studio vs KundliSoft, Kundlistar Studio, KundliSoft alternative, astrology software comparison, KP astrology software, Nadi astrology app"
    />

    <Box sx={{ bgcolor: '#f7fbf8', py: { xs: 6, md: 10 } }}>
      <Container maxWidth="md">
        <Typography variant="h2" component="h1" sx={{ fontWeight: 600, mb: 2 }}>
          Kundlistar Studio vs KundliSoft
        </Typography>
        <Typography variant="h6" color="text.secondary" sx={{ lineHeight: 1.7 }}>
          Kundlistar Studio and KundliSoft are different astrology software platforms. Kundlistar
          Studio is an iPhone astrology workspace with Vedic, KP, Nadi, BNN, Jaimini, Western
          Astrology, Numerology, timing tools and client management.
        </Typography>
      </Container>
    </Box>

    <Container maxWidth="md" sx={{ py: 7 }}>
      <Typography variant="h4" component="h2" sx={{ fontWeight: 600, mb: 2 }}>
        What makes Kundlistar Studio different?
      </Typography>
      <List>
        {[
          'Built as an astrology workspace for iPhone',
          'Supports Vedic, KP, Nadi, BNN and Jaimini systems',
          'Includes Lal Kitab, Panch Pakshi, Transit and Horary tools',
          'Includes Vedic Numerology and Lo Shu Grid',
          'Includes client CMS, planner, notes and saved charts',
        ].map((item) => (
          <ListItem key={item} disableGutters>
            <ListItemText primary={item} />
          </ListItem>
        ))}
      </List>

      <Typography variant="h4" component="h2" sx={{ fontWeight: 600, mb: 2, mt: 4 }}>
        Is Kundlistar Studio the same as KundliSoft?
      </Typography>
      <Typography paragraph>
        No. Kundlistar Studio is an independent astrology workspace available at
        kundlistarstudio.com and on the Apple App Store.
      </Typography>
    </Container>
  </>
);

export default KundlistarVsKundliSoft;
